import React from "react";
import direction from "../../../service/direction.json";
import { Player } from "video-react";
import "video-react/dist/video-react.css";
const VirtualLandlinePhoneFeatures = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-8">
        <div style={{ width: "18rem;", fontSize: "20px" }}>
          <div className="card-body">
            <h5 className="card-title text-bold" style={{ fontSize: "30px" }}>
              امکانات تلفن ثابت مجازی (سرویس هاستد)
            </h5>
            <p className="card-text">
              <ol type="1">
                <li>
                  <span className="text-bold">
                    منوی صوتی IVR (Interactive Voice Response):
                  </span>
                  همان پیام صوتی خوشامدگویی است. زمانیکه با تلفن ابری شما تماس
                  گرفته می شود این صوت پخش خواهد شد که معمولا معرفی شرکت، اعلام
                  منوها و شماره های داخلی مختلف است و مخاطب با وارد کردن اعداد 1
                  الی 9 یا هر داخلی دیگر به بخش مربوطه دایورت می شود.
                </li>
                <br />
                <li>
                  <span className="text-bold">داخلی های مختلف:</span>
                  شما میتوانید داخلی های مختلف با اعداد سه رقمی مانند داخلی 101
                  و 102 و … تعریف کنید که هر داخلی به شماره تلفن واقعی (تلفن
                  ثابت و یا موبایل و یا حتی تلفن ابری دیگر) دلخواه دایورت شود.
                </li>
                <br />
                <li>
                  <span className="text-bold">صف تماس و صف انتظار:</span>
                  شما میتوانید چندین صف تماس سه لایه تعریف کنید که مثلا اگر کسی
                  داخلی 1 را انتخاب کرد و کارمند مربوطه تا 20 ثانیه تلفن را پاسخ
                  نداد به داخلی کارمند دوم دایورت شود و اگر دومی هم پاسخ نداد به
                  سومی دایورت شود. ضمنا در این مدت انتظار نوبت مخاطب به وی اعلام
                  میشود که مثلا شما دومین نفر در صف انتظار هستید.
                </li>
                <br />
                <li>
                  <span className="text-bold">برقراری تماس خروجی:</span>
                  پیش از این سرویس های تلفن مجازی دیگری هم ارائه میشد که فقط
                  یکطرفه دریافت تماس بود ولی الان در سرویس تلفن ثابت ابری علاوه
                  بر تماس ورودی، قابلیت تماس خروجی نیز دارید یعنی میتوانید با
                  شماره ابری خود با هر شماره تلفن واقعی دیگر تماس بگیرید.
                </li>
                <br />
                <li>
                  <span className="text-bold">گزارشات تماس:</span>
                  گزارش تمامی تماس های در پنل قابل مشاهده و بررسی است.
                </li>
                <br />
                <li>
                  <span className="text-bold">ارسال و دریافت فکس:</span>
                  سرویس تلفن ابری علاوه بر امکانات تماس و مکالمه، امکان ارسال
                  فکس را نیز دارد و میتوانید با شماره تلفن ابری خود اقدام به
                  ارسال و حتی دریافت فکس کنید.
                </li>
              </ol>
              در مورد نحوه تنظیمات سرویس هاستد، ویدیوی زیر را مشاهده کنید.
            </p>
          </div>
        </div>
      </div>
      <div className="row col-md-4 text-center">
        <img
          src={`${direction.ImgDesign}sip-trunk-hosted-option.jpg`}
          alt="سایه بان"
        />
        <img
          src={`${direction.ImgDesign}hosted-cloud-phone1.jpg`}
          alt="سایه بان"
        />
      </div>
      <Player
        playsInline
        poster="/assets/poster.png"
        src="video/62809802c5b135624b0576fe3c3af56e27025513-720p.mp4"
      />
    </div>
  );
};

export default VirtualLandlinePhoneFeatures;
